import cx from 'clsx';
import React from 'react';
import { v4 as uuidv4 } from 'uuid';

import SkeletonBlock from '@components/common/Skeleton/SkeletonBlock';

import useTranslation from '@hooks/useTranslation';

import style from './style.module.scss';

const EquipmentDetailsInformationSkeleton = () => {
  const { t } = useTranslation();

  return (
    <div className={style.sensor}>
      <div className={style.blockTitle}>{t('Technical information')}</div>
      <div className={cx(style.blockContainer, style.skeletonBlockContainer)}>
        <div className={style.extraInfo}>
          <SkeletonBlock className={style.skeletonSquare} />
          {[...Array(4)].map((_) => (
            <SkeletonBlock key={uuidv4()} className={style.skeletonText} />
          ))}
        </div>
        <div className={style.mainInfo}>
          {[...Array(5)].map((_) => (
            <SkeletonBlock key={uuidv4()} className={style.skeletonText} />
          ))}
        </div>
        <div className={style.galleryBlock}>
          <SkeletonBlock className={style.skeletonGallery} />
        </div>
      </div>
    </div>
  );
};

export default EquipmentDetailsInformationSkeleton;
